"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var drawer_constants_1 = require("./drawer-constants");
var DrawerTypes;
(function (DrawerTypes) {
    DrawerTypes[DrawerTypes["EDITOR"] = 1] = "EDITOR";
})(DrawerTypes = exports.DrawerTypes || (exports.DrawerTypes = {}));
var DrawerConfigs = /** @class */ (function () {
    function DrawerConfigs() {
    }
    DrawerConfigs.EDITOR = {
        typeId: DrawerTypes.EDITOR,
        openEventName: drawer_constants_1.DrawerConstants.OPEN_DOCUMENT_EDITOR,
        closeEventName: drawer_constants_1.DrawerConstants.CLOSE_DOCUMENT_EDITOR
    };
    return DrawerConfigs;
}());
exports.DrawerConfigs = DrawerConfigs;
//# sourceMappingURL=drawer-configs.js.map